import { useAction } from '@reatom/npm-react'
import { useEffect, useMemo } from 'react'
import { useLatest } from 'react-use'
import styled, { css } from 'styled-components'

import { AppDataTable } from '@root/features/app-data-table/app-data-table'

import { reatomPositionsTable } from '../atoms'

import type { PositionsTableModel } from '../atoms'
import type {
  AggregatedPositionModel,
  WalletPositionModel,
} from '@root/entities/position'
import type { ClassNameProps } from '@root/shared/react'

export type PositionsTableProps = {
  onRowClick?: (value: AggregatedPositionModel | WalletPositionModel) => void
  onOpenWalletPositions?: (value: AggregatedPositionModel) => void
  model?: PositionsTableModel
} & ClassNameProps

export const PositionsTable: React.FC<PositionsTableProps> = ({
  className,
  onRowClick,
  model: initialModel,
  onOpenWalletPositions,
}) => {
  const model = useMemo(
    // eslint-disable-next-line @reatom/unit-naming-rule
    () => initialModel ?? reatomPositionsTable(),
    [initialModel],
  )
  const initialize = useAction(model.initialize)

  useEffect(() => {
    if (initialModel) {
      return
    }
    return initialize()
  }, [initialModel, initialize])

  const onOpenWalletPositionsRef = useLatest(onOpenWalletPositions)

  const ctxValue = useMemo(
    () => ({
      onOpenWalletPositions: (value: AggregatedPositionModel) =>
        onOpenWalletPositionsRef.current?.(value),
    }),
    [onOpenWalletPositionsRef],
  )

  return (
    <Root className={className}>
      <AppDataTable
        css={css`
          height: 100%;
        `}
        model={model}
        rowHeight={40}
        onRowClick={onRowClick}
        context={ctxValue}
      />
    </Root>
  )
}

const Root = styled.div``
